import React from 'react';
import { styled } from '@compiled/react';
import Heading from '@atlaskit/heading';
import { useIntl } from '@atlassian/jira-intl';
import { inMonthOrder } from '../messages';

type APIProps = {
	monthNumber: number;
	yearCaption: string | undefined | null;
};

type Props = APIProps;

function MonthCell(props: Props) {
	const { monthNumber, yearCaption } = props;
	const { formatMessage } = useIntl();

	return (
		<Heading level="h100">
			<Header>
				{formatMessage(inMonthOrder[monthNumber])} {yearCaption}
			</Header>
		</Heading>
	);
}

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Header = styled.span({
	textTransform: 'uppercase',
	marginTop: 0,
});

MonthCell.defaultProps = {
	yearCaption: null,
};

export default MonthCell;
export type { APIProps };
